import { Box } from '@mui/material'
import { ReactComponent as ListIcon } from 'assets/icons/list.svg'
import { ReactComponent as ArrowRight } from 'assets/icons/nav_arrow_right.svg'
import { useGetLicenses } from 'hook/query/useGetLicense'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { COLORS } from 'styles/colors'
import { CardStandart } from 'ui/CardStandart'
import { TypographyHeader } from 'ui/typography/TypographyHeader'

export const SmartFarmModules = () => {
	const { data, isLoading } = useGetLicenses()
	if (isLoading) {
		return null
	}
	const availableLicenses = Array.isArray(data)
		? data.filter(el => moment(el.until_dt).diff(moment(), 'days') > 0)
		: []
	const expirationSoon = availableLicenses?.some(
		el => moment(el.until_dt).diff(moment(), 'days') <= 30,
	)
	return (
		<Link to='/profile/licenses' style={{ padding: '0px' }}>
			<CardStandart sx={{ padding: '24px', cursor: 'pointer' }}>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							gap: '8px',
							position: 'relative',
						}}
					>
						{expirationSoon && (
							<span
								style={{
									position: 'absolute',
									left: '14px',
									top: '15px',
									width: '8px',
									height: '8px',
									backgroundColor: COLORS.orange,
									borderRadius: '50%',
								}}
							></span>
						)}
						<ListIcon />
						<TypographyHeader>Модули SMART FARM</TypographyHeader>
					</Box>
					<ArrowRight />
				</Box>
			</CardStandart>
		</Link>
	)
}
